
export default class Defs {
    public static ANALYTICS_LISTING_MAPCLICK: string = 'MapClick';
    public static ANALYTICS_LISTING_TABLECLICK: string = 'TableClick';
    public static ANALYTICS_LISTING_VIEWDETAILS: string = 'ViewDetails';
    public static ANALYTICS_OPSLAYER_CRIMEOFF: string = 'CrimeOff';
    public static ANALYTICS_OPSLAYER_CRIMEON: string = 'CrimeOn';
    public static ANALYTICS_OPSLAYER_CROWNLANDOFF: string = 'CrownLandOff';
    public static ANALYTICS_OPSLAYER_CROWNLANDON: string = 'CrownLandOn';
    public static ANALYTICS_OPSLAYER_HEATOFF: string = 'HeatOff';
    public static ANALYTICS_OPSLAYER_HEATON: string = 'HeatOn';
    public static ANALYTICS_OPSLAYER_LISTPNTSOFF: string = 'ListPntsOff';
    public static ANALYTICS_OPSLAYER_LISTPNTSON: string = 'ListPntsOn';
    public static ANALYTICS_DETAILS_PHOTOS: string = 'Photos';
    public static ANALYTICS_DETAILS_HRM: string = 'HRM';
    public static ANALYTICS_DETAILS_TAX: string = 'Tax';
    public static ANALYTICS_DETAILS_HISTORY: string = 'History';
    public static ANALYTICS_DETAILS_SCHOOLS: string = 'Schools';
    public static ANALYTICS_DETAILS_DEMO: string = 'Demographics';
    public static ANALYTICS_DETAILS_STREETVIEW: string = 'StreetView';

    public static LISTING_NO_VALUE: string = 'n/a';
    public static LISTING_NO_VALUE_NUM: number = 0;
}
